import { render, staticRenderFns } from "./guide-lag-performance.vue?vue&type=template&id=1e0b561f"
import script from "./guide-lag-performance.vue?vue&type=script&lang=js"
export * from "./guide-lag-performance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports